import {Category} from "./category";

export class Membership{
    athleteId?: string;
    badgeDetails?: string;
    badgeExpiration? :string;
    category?: Category;
    categoryId?: string;
    createdAt?: string;
    federationName?: string;
    id?: string;
    registered?: number;
    signed?: string;
    status?: string;
    updatedAt?: string;

    constructor(raw?: Membership) {
        if (raw) {
            this.athleteId = raw.athleteId;
            this.badgeDetails = raw.badgeDetails;
            this.badgeExpiration = raw.badgeExpiration;
            this.category = new Category(raw.category);
            this.categoryId = raw.categoryId;
            this.createdAt = raw.createdAt;
            this.federationName = raw.federationName;
            this.id = raw.id;
            this.registered = raw.registered;
            this.signed = raw.signed;
            this.status = raw.status;
            this.updatedAt = raw.updatedAt;
        }
    }
}
